import React from 'react'
import { ReactComponent as Icon } from "../assets/svg/cancel.svg"
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

export interface IUnauthorizedBlockButton {
    label: string,
    link?: string,
    onClick?: () => void,
    variant?: 'text' | 'outlined' | 'contained',
    addClassName?: string,
    color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
    disabled?: boolean
}

interface IProps {
    title?: string,
    message?: string,
    buttons?: IUnauthorizedBlockButton[]
}

export default function UnauthorizedBlock(props: IProps) {

    const navigate = useNavigate()

    const { title, message } = props

    const buttons: IUnauthorizedBlockButton[] = props.buttons ? props.buttons : [
        {
            label: "Home",
            link: "/",
            variant: "outlined"
        },
        {
            label: "Logout",
            link: "/logout",
            variant: "text"
        }
    ]

    return(
        <div className="nothing-found-block unauthorized">
            <div className="content-of-nothing-found-block">

                <Icon />
                <h3>{title ? title : "Unauthorized"}</h3>
                <p>{message ? message : "You don't have the access to this page"}</p>

                {buttons && buttons.length > 0 && (
                    <div className="buttons-of-nothing-found-block">
                        <div className="content-of-buttons-of-nothing-found-block">
                            {buttons.map((button, index) => {

                                const onClick = () => {
                                    if (button.onClick){
                                        button.onClick()
                                    }

                                    if (button.link){
                                        navigate(button.link)
                                    }
                                }

                                return <Button disabled={button.disabled} color={button.color ? button.color : "primary"} onClick={() => onClick()} className={button.addClassName ? `general-button admin-style ${button.addClassName}` : "general-button admin-style"} variant={button.variant ? button.variant : "contained"}>{button.label}</Button>
                            })}
                        </div>
                    </div>
                )}

            </div>
        </div>
    )
}